import { isPresent } from 'utils/isPresent';
import React, { memo } from 'react'
import { compose } from 'redux'
import moment from 'moment-timezone'
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button'
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid'
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography'
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles'
import ScheduleDateIcon from 'housecall-ui/dist/IconsAndImages/Icons/Event'
import TextField from 'housecall-ui/dist/DesignSystem/Inputs/TextFields/TextField'

const styles = theme => ({
  buttonWrapper: {
    padding: 8,
  },
  scheduleDateButton: {
    width: '100%',
    color: theme.palette.secondary.light,
    textTransform: 'none',
    padding: 8,
  },
  buttonText: {
    color: theme.palette.secondary.light,
  },
  textField: {
    width: '100%',
  },
  textFieldContainer: {
    width: '90%',
  },
  iconWrapper: {
    padding: 8,
  },
})

const CreateUpdateDateSelection = ({
  classes,
  disabled,
  due,
  error,
  label,
  onDueDateChange,
}) => {
  const handleDueDateChange = () =>
    onDueDateChange(moment().format('YYYY-MM-DD'))

  const handleDateInputChange = event => {
    if (!isPresent(event.target.value)) return onDueDateChange(null)

    return onDueDateChange(moment(event.target.value).format('YYYY-MM-DD'))
  }

  return (
    <React.Fragment>
      {isPresent(due) ? (
        <Grid item xs={12} className={classes.textFieldContainer}>
          <TextField
            error={error}
            id="date"
            label={label}
            type="date"
            disabled={disabled}
            defaultValue={due}
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={handleDateInputChange}
          />
        </Grid>
      ) : (
        <Grid
          container
          item
          className={classes.textFieldContainer}
          alignItems="center"
          justify="flex-start"
          wrap="nowrap"
          spacing={24}
          xs={12}
        >
          <div className={classes.iconWrapper}>
            <ScheduleDateIcon className={classes.buttonText} />
          </div>
          <div className={classes.buttonWrapper}>
            <Button
              className={classes.scheduleDateButton}
              size="small"
              disabled={disabled}
              onClick={handleDueDateChange}
            >
              <Typography variant="body1" className={classes.buttonText} noWrap>
                Add date
              </Typography>
            </Button>
          </div>
        </Grid>
      )}
    </React.Fragment>
  )
}

export default compose(withStyles(styles), memo)(CreateUpdateDateSelection)
